import React from 'react';
import * as acessos from '../../../acessos.const.util';
import './multinotas.styles.css';
import IntlMessage from '../../../helpers/intlMessage';

const MultiNotasPage = (props) => {
  return (
    props.acessoPermitido(props.usuario, acessos.Notas) &&
    props.acessoPermitido(props.usuario, acessos.Adicionar) && (
      <React.Fragment>
        {props.listagemNotas && props.listagemNotas.length > 0 ? (
          <div className='mv-multinotas-container'>
            <div className='responsive'>
              <table id='notas-table' className='table table-hover'>
                <thead>
                  <tr className='thead'>
                    <th>ID</th>
                    <th><IntlMessage id = "general.requestsPanel.date"/></th>
                    <th><IntlMessage id = "general.requestsPanel.performer"/></th>
                    <th><IntlMessage id = "dashboards.examDetail.crm"/></th>
                    <th><IntlMessage id = "dashboards.examDetail.reviewer"/></th>
                  </tr>
                </thead>
                <tbody style={{ cursor: 'pointer' }}>
                  {props.listagemNotas.map((nota) => (
                    <tr key={nota.id_laudo_texto}>
                      <td>{nota.id_laudo_texto}</td>
                      <td>{nota.dataHoraCriacao}</td>
                      <td>{nota.nm_executante}</td>
                      <td>{nota.crm_executante}</td>
                      <td>{nota.nm_revisor}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ) : (
          <div className='table-loader-container'>
            <div className='table-loader'></div>
          </div>
        )}
      </React.Fragment>
    )
  );
};

export default MultiNotasPage;



// WEBPACK FOOTER //
// ./src/app/common/multinotas/multinotas.page.js